import PropTypes from "prop-types";
import React, { Component } from "react";

import ChatActions from "../../../actions/ChatActions";
import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";
import MessageType from "../../../constants/ChatMessageTypes";

class AcceptResponseSystemMessage extends Component {
    constructor() {
        super();

        this.onAcceptResponse = this.onAcceptResponse.bind(this);
        this.onAcceptResponseSubmit = this.onAcceptResponseSubmit.bind(this);
        this.onAcceptResponseKeyPress = this.onAcceptResponseKeyPress.bind(this);
    }

    onAcceptResponse(event) {
        const { confirmAccepts } = this.props.question;

        if (confirmAccepts) {
            const acceptResponseButton = {
                label: i18n.t("rtm.button.accept_and_close"),
                onClick: this.onAcceptResponseSubmit,
            };
            const closeActionBarButton = {
                label: i18n.t("rtm.button.not_yet"),
                onClick: ChatActions.clearActionBar.defer,
            };

            ChatActions.createActionBar({
                buttons: [acceptResponseButton, closeActionBarButton],
                messageType: MessageType.AcceptResponseConfirmationMessage,
            });
        } else {
            this.onAcceptResponseSubmit();
        }
        event.preventDefault();
    }

    onAcceptResponseKeyPress(event) {
        if (event.charCode === 32 || event.charCode === 13) {
            this.onAcceptResponse(event);
        }
    }

    onAcceptResponseSubmit() {
        const { question, response } = this.props;

        ChatActions.responseAccept({
            questionUuid: question.uuid,
            responseId: response.id,
            prevHappiness: response.happiness,
        });
    }

    render() {
        const { response } = this.props;

        return (
            <li className="system-message success message-accept-response">
                <div className="icon icon-checkmark icon-success">
                    <SvgIcon src={iconSprite} id="icon-checkmark" />
                </div>
                <p className="body">
                    {i18n.t("rtm.text.make_sure_gets_credit_part_1", {
                        recognitionRecipientName: response.recognitionRecipient.name,
                    })}{" "}
                    <a onClick={this.onAcceptResponse} onKeyPress={this.onAcceptResponseKeyPress} tabIndex={0}>
                        <strong>{i18n.t("rtm.text.make_sure_gets_credit_part_2")}</strong>
                    </a>
                    .
                </p>
            </li>
        );
    }
}

AcceptResponseSystemMessage.propTypes = {
    question: PropTypes.object.isRequired,
    response: PropTypes.object.isRequired,
};

export default AcceptResponseSystemMessage;
